import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import ExamAnalysisContent from '../components/exam-analysis/ExamAnalysisContent';
import ExamAnalysisProvider from '../providers/ExamAnalysisProvider';

function toBoolean(value?: any): boolean {
  if (!value) {
    return false;
  }
  return value === 'true' || value === 1 || value === true;
}

const ExamAnalysisFreePage: FC = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  return (
    <main className="main">
      <div className="main__container">
        <ExamAnalysisProvider institutionName={params.get('institution') ?? ''} ufName={params.get('uf') ?? ''}>
          <ExamAnalysisContent hideForm={toBoolean(params.get('hideForm'))} />
        </ExamAnalysisProvider>
      </div>
    </main>
  );
};

export default ExamAnalysisFreePage;
